import React, { useState } from 'react';
import PageHeader from '../components/PageHeader'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import ScrollReveal from '../components/ScrollReveal';

const faqData = [
    {
        question: 'What is a virtual tour?',
        answer: 'A virtual tour is an interactive online experience that allows you to explore a location remotely. Using 360-degree imagery, videos, and other multimedia content, you can navigate through a space as if you were there in person.',
    },
    {
        question: 'What equipment do I need to experience a virtual tour?',
        answer: 'You can experience our virtual tours on any device with an internet connection, including computers, tablets, and smartphones. While not required, VR headsets can enhance the immersive experience.',
    },
    {
        question: 'How do I book a virtual tour?',
        answer: 'To book a virtual tour, visit our "Travel Guides" page, select the tour you\'re interested in, and follow the booking instructions. You\'ll receive a confirmation email with all the details you need.',
    },
    {
        question: 'Are the virtual tours live or pre-recorded?',
        answer: 'Our virtual tours are primarily pre-recorded to ensure a high-quality and consistent experience. However, we also offer live guided tours on occasion. Check our schedule for upcoming live events.',
    },
    {
        question: 'Can I ask questions during a virtual tour?',
        answer: 'During our pre-recorded tours, you can\'t ask questions in real-time. However, if you have any questions or need assistance, feel free to contact us via our "Contact Us" page.',
    },
    {
        question: 'What is your cancellation policy?',
        answer: 'Our cancellation policy varies depending on the type of tour. Please refer to the specific tour\'s details for more information.',
    },
    {
        question: 'Do you offer group discounts?',
        answer: 'Yes, we offer discounts for group bookings. Please contact us for more information.',
    },
    {
        question: 'How can I provide feedback on a virtual tour?',
        answer: 'We welcome your feedback! After completing a tour, you\'ll receive a feedback form via email. You can also contact us directly through our "Contact Us" page.',
    },
];

const Faqs = () => {
    const [expandedQuestion, setExpandedQuestion] = useState(null);

    const toggleQuestion = (index) => {
        setExpandedQuestion(expandedQuestion === index ? null : index);
    };

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <PageHeader />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/tourist-carrying-luggage.jpg')" }}>
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <div className="text-center text-white px-4">
                            <h1 className="text-5xl md:text-6xl font-cormorant-upright font-bold">Frequently Asked Questions</h1>
                            <p className="mt-4 text-sm md:text-sm max-w-3xl mx-auto">Everything you need to know about our virtual tours and services.</p>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section className="py-20 px-4">
                    <div className="container mx-auto max-w-3xl">
                        {faqData.map((faq, index) => (
                            <div key={index} className="mb-6">
                                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={index * 100}>
                                <div
                                    className="flex justify-between items-center bg-gray-100 p-4 rounded-t-lg cursor-pointer"
                                    onClick={() => toggleQuestion(index)}
                                >
                                    <h3 className="text-base font-semibold">{faq.question}</h3>
                                    {expandedQuestion === index ? (
                                        <FaChevronUp className="text-gray-600" />
                                    ) : (
                                        <FaChevronDown className="text-gray-600" />
                                    )}
                                </div>
                                </ScrollReveal>
                                {expandedQuestion === index && (
                                    <div className="bg-white p-4 rounded-b-lg shadow-md">
                                        <p className="text-sm font-semibold text-gray-700">{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default Faqs